import piLogo from './pi-impact-logo.png';
import rtzAcceleratorLogo from './rtz-acc-logo.png';
import rtzLogo from './rtz-logo.png';

const images = {
    piLogo,
    rtzAcceleratorLogo,
    rtzLogo
};

export default images;
